/* Judge.me 評論輪播箭頭失效兜底（KR/JP/HK 共用）：
   覆蓋兩代 widget：
   - 舊版 carousel：箭頭 .jdgm-carousel__left/right-arrow，
     軌道 .jdgm-carousel__item-wrapper，位移 = translate3d(-N px)
   - 新版 snippet：箭頭 .jdgm-rev-snippet-widget__prev/next-btn，
     軌道 __cards-container，位移 = translateX(-index*cardWidth px)
   點擊後等 80ms——若 Judge.me 原生 handler 已生效（軌道已位移）則退出；
   原生失效時優先調用 jdgm.performSliding（App 自己的滑動邏輯），
   拿不到 jdgm API 才手動改 transform。 */
(function () {
  function tx(el) {
    var m = /translate3d?\(\s*(-?[\d.]+)px/.exec((el && el.style.transform) || '');
    return m ? parseFloat(m[1]) : 0;
  }
  function cardStep(track) {
    var it = track.querySelector('.jdgm-carousel-item, .jdgm-rev-snippet-card');
    if (!it) return 0;
    var cs = getComputedStyle(it);
    return it.getBoundingClientRect().width +
      (parseFloat(cs.marginLeft) || 0) + (parseFloat(cs.marginRight) || 0);
  }
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var arrow = e.target.closest(
      '.jdgm-carousel__left-arrow, .jdgm-carousel__right-arrow,' +
      '.jdgm-carousel__left-arrow-icon, .jdgm-carousel__right-arrow-icon,' +
      '.jdgm-rev-snippet-widget__prev-btn, .jdgm-rev-snippet-widget__next-btn'
    );
    if (!arrow) return;
    var dir = /left|prev/.test(arrow.className) ? -1 : 1;

    var wrap = arrow.closest('.jdgm-carousel-wrapper');
    var snip = arrow.closest('.jdgm-review-snippet-widget, .jdgm-review-snippet-widget-wrapper');
    var track, posBefore;
    if (wrap) {
      track = wrap.querySelector('.jdgm-carousel__item-wrapper');
    } else if (snip) {
      track = snip.querySelector('.jdgm-rev-snippet-widget__cards-container');
    }
    if (!track) return;
    posBefore = tx(track);

    setTimeout(function () {
      if (Math.abs(tx(track) - posBefore) > 1) return; // 原生已接管

      if (wrap) {
        // 舊版：優先走 Judge.me 原生滑動（含循環/邊界邏輯）
        var car = wrap.querySelector('.jdgm-carousel') || wrap;
        try {
          if (window.jdgm && jdgm.$ && typeof jdgm.performSliding === 'function') {
            jdgm.performSliding(jdgm.$(car), dir, true);
            if (Math.abs(tx(track) - posBefore) > 1) return;
          }
        } catch (err) { /* fallthrough to manual */ }
        // 手動兜底：單卡步進 + 首尾循環（對應 performSliding 的模運算）
        var step = cardStep(track);
        var count = track.querySelectorAll('.jdgm-carousel-item').length;
        if (!step || !count) return;
        var idx = Math.round(-posBefore / step);
        idx = Math.max(0, Math.min(count - 1, idx));
        idx = (idx + dir + count) % count;
        track.style.transition = 'transform .35s ease';
        track.style.transform = 'translate3d(' + (-idx * step) + 'px, 0px, 0px)';
      } else {
        // 新版 snippet：卡片寬 = wrapper 寬，index 鉗制在 [0, total-1]
        var scope = snip.closest('.jdgm-review-snippet-widget-wrapper') || snip;
        var w = scope.getBoundingClientRect().width;
        var total = track.querySelectorAll('.jdgm-rev-snippet-card').length;
        if (!w || !total) return;
        var cur = Math.max(0, Math.min(total - 1, Math.round(-posBefore / w)));
        var next = Math.max(0, Math.min(total - 1, cur + dir));
        if (next === cur) return;
        track.style.transition = 'transform 0.5s ease';
        track.style.transform = 'translateX(-' + (next * w) + 'px)';
      }
    }, 80);
  }, true);
})();
